import {ValueObject} from '@s-ui/domain'

export class SpecsValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.text
   * @param {String} params.value
   * @param {Object} params.customText
   * @param {Object} params.images
   * */

  get value() {
    return {
      text: this._text,
      value: this._value,
      customText: this._customText,
      images: this._images
    }
  }
}
